import React from "react";
import Input from "../../../../../components/FormComponents/Input";
// import Label from "../../../../../components/FormComponents/Label";
import SingleSelectBox from "../../../../../components/FormComponents/SingleSelectBox";
import currencyCodes from "currency-codes";
import { getLabelForKey } from "../../../../../utils/Config/DefaultConfig/formFieldConfig";

const EditCurrency = (props) => {
  const { editFieldData, setEditFieldData } = props;
  const handleChangeInput = (name, value) => {
    setEditFieldData({ ...editFieldData, [name]: value });
  };
  const handleChangeValidationInput = (name, value) => {
    setEditFieldData({ ...editFieldData, validate: { ...editFieldData.validate, [name]: value } });
  };

  const allCurrencyData = currencyCodes.data;

  return (
    <>
      <Input
        label={getLabelForKey("label")}
        value={editFieldData.label}
        name="label"
        onChange={({ target }) => handleChangeInput(target.name, target.value)}
      />
      <Input
        label={getLabelForKey("form_display_label")}
        value={editFieldData.form_display_label}
        name="form_display_label"
        onChange={({ target }) => handleChangeInput(target.name, target.value)}
      />
      <div className="flex_row">
        <Input
          type="checkbox"
          label={getLabelForKey("required")}
          checked={editFieldData.validate.required}
          name="required"
          onChange={({ target }) => handleChangeValidationInput(target.name, target.checked)}
          containerClassName="w_50"
        />
        <Input
          type="checkbox"
          label={getLabelForKey("disable")}
          checked={editFieldData.disable}
          name="disable"
          onChange={({ target }) => handleChangeInput(target.name, target.checked)}
          containerClassName="w_50"
        />
      </div>
      <Input
        type="checkbox"
        label={getLabelForKey("backend_validation")}
        checked={editFieldData.validate.backend_validation}
        name="backend_validation"
        size="medium"
        containerClassName="w_50"
        onChange={({ target }) => handleChangeValidationInput(target.name, target.checked)}
      />
      <div className="field_horizontal_container">
        <div className="flex_row w_50 gap_2">
          <Input
            type="number"
            value={editFieldData.validate.max_digit}
            name="max_digit"
            onChange={({ target }) => handleChangeValidationInput(target.name, target.value)}
            label={getLabelForKey("max_digit")}
          />
          <Input
            type="number"
            value={editFieldData.validate.decimal_point}
            name="decimal_point"
            onChange={({ target }) => handleChangeValidationInput(target.name, target.value)}
            label={getLabelForKey("decimal_point")}
          />
        </div>
        <div className="w_50"></div>
      </div>

      <SingleSelectBox
        selectedData={editFieldData.currency}
        options={allCurrencyData}
        valueKey="code"
        labelKey={["code", "currency"]}
        onChange={(curr) => handleChangeInput("currency", curr.code)}
        label="Default currency type"
        isSearch={true}
      />
      <div className="field_horizontal_container">
        <Input
          label={getLabelForKey("help_text")}
          value={editFieldData.help_text}
          name="help_text"
          onChange={({ target }) => handleChangeInput(target.name, target.value)}
        />
      </div>
    </>
  );
};

export default EditCurrency;
